module.exports = __webpack_public_path__ + "img/logo.985864d8.png";